import { render, staticRenderFns } from "./full-article-requests.vue?vue&type=template&id=486ffa82&scoped=true"
import script from "./full-article-requests.vue?vue&type=script&lang=js"
export * from "./full-article-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ffa82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486ffa82')) {
      api.createRecord('486ffa82', component.options)
    } else {
      api.reload('486ffa82', component.options)
    }
    module.hot.accept("./full-article-requests.vue?vue&type=template&id=486ffa82&scoped=true", function () {
      api.rerender('486ffa82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/se/view/full-article-requests.vue"
export default component.exports